'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgFlag = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M5.67 5.34c.01-.73-.59-1.33-1.32-1.34h-.01c-.73-.01-1.33.59-1.34 1.32v.02c-.01.48.25.93.67 1.15v13.17c0 .18.15.33.33.34h.67c.18-.01.33-.16.33-.34V6.48c.42-.22.68-.67.67-1.15v.01zM21 6a.683.683 0 0 0-.67-.67c-.2.04-.39.11-.57.22l-.91.45c-.37.2-.75.36-1.15.49-.39.14-.8.21-1.22.22-.32.01-.63-.06-.92-.2-.74-.36-1.5-.66-2.28-.92a6.98 6.98 0 0 0-2.08-.3 9.95 9.95 0 0 0-4.38 1.3c-.28.12-.55.26-.82.41a.73.73 0 0 0-.32.57v7.73c.01.37.3.66.67.67.12 0 .24-.03.34-.09 1.46-.89 3.12-1.41 4.83-1.52.5 0 1 .08 1.48.23.42.13.82.29 1.2.5.36.2.74.37 1.13.5.41.15.85.23 1.29.23 1.36-.09 2.68-.5 3.84-1.21.15-.07.29-.17.41-.29.09-.11.14-.25.13-.4V6z",
  vectorEffect: "non-scaling-stroke",
  fill: "currentColor"
})));

exports["default"] = SvgFlag;
